app.factory('authModel', ['$rootScope', 'baseModel', 'authService',
    function ($rootScope, baseModel, authService) {

        function AuthModel() {

            this.authenticate = function (username, password) {
                authService.authenticate(username, password).then(
                    function (token) {
                        $rootScope.$broadcast(Event.AUTH.AUTHENTICATE.SUCCESS, token);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.AUTH.AUTHENTICATE.ERROR, error);
                    }
                )
            };

            this.invalidate = function () {
                authService.invalidate().then(
                    function (token) {
                        $rootScope.$broadcast(Event.AUTH.INVALIDATE.SUCCESS, token);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.AUTH.INVALIDATE.ERROR, error);
                    }
                )
            };
        }

        return new AuthModel();
    }
]);
